import * as R from "ramda";
export const checkFirstPage = () => {
    if (typeof window !== "undefined") {
        localStorage.removeItem("first_url");
        window.localStorage.setItem("first_url", R.pathOr("", ["location", "href"])(window));
    }
};

export const checkUTM = () => {
    if (typeof window !== "undefined") {
        localStorage.removeItem("utm_data");
        const searchParams = new URLSearchParams(R.pathOr("", ["location", "search"])(window));
        let utmData = {
            utm_source: searchParams.get("utm_source"),
            utm_medium: searchParams.get("utm_medium"),
            utm_campaign: searchParams.get("utm_campaign"),
            utm_term: searchParams.get("utm_term"),
            utm_content: searchParams.get("utm_content"),
        };
        localStorage.setItem("utm_data", JSON.stringify(utmData));
    }
};

export interface utmProps {
    utm_campaign: string | null;
    utm_content: string | null;
    utm_medium: string | null;
    utm_source: string | null;
    utm_term: string | null;
}
